import { Observable } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { Department } from "src/app/_models/department";
import { environment } from 'src/environments/environment';  // Importa environment per la base URL

export class DepartmentApiService {
    constructor(private _ws: WebServicesService) {}

    // Department methods
    get(): Observable<Department[]> {
        const url = `${environment.wsBaseUrl}/api/Department`;
        return this._ws.getWithoutCache(url);
    }

    post(department: Department): Observable<any> {
        const url = `${environment.wsBaseUrl}/api/Department`;
        return this._ws.postJson(url, department);
    }

    put(department: Department): Observable<any> {
        const url = `${environment.wsBaseUrl}/api/Department/${encodeURIComponent(department.id)}`;
        return this._ws.putJson(url, department);
    }

    delete(id: number): Observable<any> {
        const url = `${environment.wsBaseUrl}/api/Department/${encodeURIComponent(id)}`;
        return this._ws.deleteHttp(url);
    }
}
